/* NVN Marine — header autocomplete
 *
 * Single-column dropdown matching the original Liquid layout:
 *   - Products (from ES /autocomplete)
 *   - Collections (from Shopify /search/suggest.json)
 *   - Articles (from Shopify /search/suggest.json)
 *   - "View all results for X" footer
 *
 * ES powers products only — collections and blog posts come from Shopify so
 * they always reflect what's actually live in the store.
 */
(function () {
  'use strict';

  var NVN = (window.NVN = window.NVN || {});
  var DEBOUNCE = 180;
  var MIN_CHARS = 2;

  function dec(s) { return (NVN.decode || function (v) { return v == null ? '' : String(v); })(s); }
  function esc(s) {
    return dec(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escAllowEm(s) {
    var safe = esc(s);
    return safe.replace(/&lt;em&gt;/g, '<em>').replace(/&lt;\/em&gt;/g, '</em>');
  }

  function searchUrl(q) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.search_url) || '/search';
    return root + '?q=' + encodeURIComponent(q || '');
  }

  /* -- Shopify predictive search for collections + articles --------------- */
  var shopifyController = null;
  function shopifyPredictive(term) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.predictive_search_url) || '/search/suggest';
    var url = root + '.json?q=' + encodeURIComponent(term) +
      '&resources[type]=collection,article' +
      '&resources[limit]=4' +
      '&resources[options][unavailable_products]=last';
    if (shopifyController) try { shopifyController.abort(); } catch (_) {}
    shopifyController = new AbortController();
    return fetch(url, { signal: shopifyController.signal })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function renderProducts(items) {
    if (!items || !items.length) return '';
    var max = (NVN.config && NVN.config.autocompleteCount) || 8;
    var html = '<div class="ps-section"><div class="ps-section-label">Products</div>';
    items.slice(0, max).forEach(function (p) {
      var url = '/products/' + (p.handle || '');
      html += '<a href="' + esc(url) + '" class="ps-product" data-ps-item>';
      if (p.image) {
        html += '<img class="ps-product-img" src="' + esc(p.image) + '" alt="' + esc(p.title || '') +
          '" width="44" height="44" loading="lazy">';
      } else {
        html += '<div class="ps-product-img-placeholder"></div>';
      }
      html += '<div class="ps-product-info">';
      if (p.vendor) html += '<div class="ps-product-vendor">' + esc(p.vendor) + '</div>';
      html += '<div class="ps-product-title">' + (p.highlighted ? escAllowEm(p.highlighted) : esc(p.title || '')) + '</div>';
      html += '<div class="ps-product-price">' + (NVN.money ? NVN.money(p.price) : '$' + p.price) + '</div>';
      html += '</div>';
      if (p.in_stock === false) html += '<span class="ps-product-badge">Sold out</span>';
      html += '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderCollections(items) {
    if (!items || !items.length) return '';
    var html = '<div class="ps-section"><div class="ps-section-label">Collections</div>';
    items.slice(0, 4).forEach(function (c) {
      html += '<a href="' + esc(c.url) + '" class="ps-article" data-ps-item>' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>' +
        '<span>' + esc(c.title) + '</span>' +
      '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderArticles(items) {
    if (!items || !items.length) return '';
    var html = '<div class="ps-section"><div class="ps-section-label">Articles</div>';
    items.slice(0, 3).forEach(function (a) {
      html += '<a href="' + esc(a.url) + '" class="ps-article" data-ps-item>' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '<span>' + esc(a.title) + '</span>' +
      '</a>';
    });
    html += '</div>';
    return html;
  }

  function renderEmpty(term) {
    return '<div class="ps-no-results">No results for "<strong>' + esc(term) + '</strong>"</div>';
  }

  function renderFooter(term) {
    return '<div class="ps-footer">' +
      '<a href="' + esc(searchUrl(term)) + '" class="ps-view-all" data-ps-item>' +
      'View all results for "' + esc(term) + '"' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
      '</a></div>';
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;
    dropdown.hidden = true;
    dropdown.innerHTML = '';
  }

  var debounceTimer = null;

  async function runQuery(term, dropdown) {
    if (!NVN.search) return;
    var [esRes, shopifyJson] = await Promise.all([
      NVN.search.autocomplete(term),
      shopifyPredictive(term)
    ]);
    if (esRes.aborted) return;

    var products = (esRes.ok && esRes.json && esRes.json.data && esRes.json.data.suggestions) || [];
    var sr = (shopifyJson && shopifyJson.resources && shopifyJson.resources.results) || {};
    var collections = sr.collections || [];
    var articles = sr.articles || [];

    var body = renderProducts(products) + renderCollections(collections) + renderArticles(articles);
    if (!body) body = renderEmpty(term);

    dropdown.innerHTML = body + renderFooter(term);
    dropdown.hidden = false;
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-predictive-search-input]');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    var dropdown = form.querySelector('[data-predictive-search]');
    if (!dropdown) return;
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length < MIN_CHARS) { closeDropdown(dropdown); return; }
    debounceTimer = setTimeout(function () { runQuery(term, dropdown); }, DEBOUNCE);
  });

  // Keyboard nav
  document.addEventListener('keydown', function (e) {
    var dropdown = document.querySelector('[data-predictive-search]:not([hidden])');
    if (!dropdown) return;
    var items = Array.from(dropdown.querySelectorAll('[data-ps-item]'));
    if (!items.length) return;
    var active = dropdown.querySelector('.ps-active');
    var idx = active ? items.indexOf(active) : -1;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (active) active.classList.remove('ps-active');
      items[(idx + 1) % items.length].classList.add('ps-active');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (active) active.classList.remove('ps-active');
      items[(idx - 1 + items.length) % items.length].classList.add('ps-active');
    } else if (e.key === 'Enter' && active) {
      e.preventDefault();
      active.click();
    } else if (e.key === 'Escape') {
      var input = document.querySelector('[data-predictive-search-input]');
      if (input) { input.blur(); }
      document.querySelectorAll('[data-predictive-search]').forEach(closeDropdown);
    }
  });

  // Close on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.header-search') && !e.target.closest('.mobile-search-form')) {
      document.querySelectorAll('[data-predictive-search]').forEach(closeDropdown);
    }
  });
})();
